/* Valoriet — interacciones propias (sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vl-reveal:not(.vl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-vl-cifra]:not([data-vl-hecha])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-vl-hecha', '');
      var fin = parseFloat(el.getAttribute('data-vl-cifra')) || 0;
      var sufijo = el.getAttribute('data-vl-sufijo') || '';
      if (reduce) { el.textContent = fin + sufijo; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-vl-galeria]').forEach(function (gal) {
      if (gal.hasAttribute('data-vl-lista')) return;
      gal.setAttribute('data-vl-lista', '');
      var principal = gal.querySelector('[data-vl-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-vl-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = btn.getAttribute('data-srcset') || '';
          principal.alt = btn.getAttribute('data-alt') || '';
          gal.querySelectorAll('[data-vl-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });
    });
  }

  function formatoDinero(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto() {
    document.querySelectorAll('[data-vl-producto]').forEach(function (raiz) {
      if (raiz.hasAttribute('data-vl-lista')) return;
      raiz.setAttribute('data-vl-lista', '');
      var form = raiz.querySelector('form[action*="/cart/add"]');
      var cantidad = raiz.querySelector('[data-vl-cantidad]');
      raiz.querySelectorAll('[data-vl-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cantidad.value, 10) || 1;
          cantidad.value = Math.max(1, v + parseInt(b.getAttribute('data-vl-cant'), 10));
        });
      });

      var datos = raiz.querySelector('[data-vl-variantes]');
      if (datos && form) {
        var variantes = JSON.parse(datos.textContent);
        var formato = raiz.getAttribute('data-vl-formato');
        var inputId = form.querySelector('input[name="id"]');
        var boton = form.querySelector('[data-vl-boton]');
        var textoBoton = boton.getAttribute('data-texto');
        var textoAgotado = boton.getAttribute('data-agotado');
        raiz.addEventListener('change', function (e) {
          if (!e.target.matches('[data-vl-opcion]')) return;
          var elegidas = Array.prototype.map.call(raiz.querySelectorAll('[data-vl-opcion]:checked'), function (i) { return i.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; return; }
          inputId.value = v.id;
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
          var actual = raiz.querySelector('[data-vl-precio]');
          var antes = raiz.querySelector('[data-vl-antes]');
          var ahorro = raiz.querySelector('[data-vl-ahorro]');
          if (actual) actual.textContent = formatoDinero(v.price, formato);
          var rebaja = v.compare_at_price && v.compare_at_price > v.price;
          if (antes) { antes.hidden = !rebaja; if (rebaja) antes.textContent = formatoDinero(v.compare_at_price, formato); }
          if (ahorro) { ahorro.hidden = !rebaja; if (rebaja) ahorro.textContent = ahorro.getAttribute('data-plantilla').replace('[%]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'); }
          if (v.featured_image) {
            var mini = raiz.querySelector('[data-vl-mini][data-media-id="' + v.featured_media_id + '"]');
            if (mini) mini.click();
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      // Añadir al carrito y abrir el cajón del carrito de Dawn (si existe); si falla, envío normal
      if (form) {
        form.addEventListener('submit', function (e) {
          var cajon = document.querySelector('cart-drawer');
          if (!cajon || typeof cajon.renderContents !== 'function') return;
          e.preventDefault();
          var boton = form.querySelector('[data-vl-boton]');
          var error = raiz.querySelector('[data-vl-error]');
          boton.disabled = true;
          var fd = new FormData(form);
          fd.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            boton.disabled = false;
            if (res.status) { if (error) { error.hidden = false; error.textContent = res.description || res.message; } return; }
            if (error) error.hidden = true;
            cajon.classList.remove('is-empty');
            cajon.renderContents(res);
          }).catch(function () { boton.disabled = false; form.submit(); });
        });
      }
    });
  }

  function initTodo() { initReveal(); initCifras(); initGaleria(); initProducto(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
